<template>
    <div class="px-8 m-auto">
        <h1 class="text-center text-gray-700 dark:text-indigo-400 text-3xl">Painel Varejo Opinião</h1>
        <h1 class="text-center text-gray-500 dark:text-indigo-100 text-lg">Esqueceu a senha?</h1>
        <p class="mt-4 text-center text-gray-500 dark:text-gray-400">Insira o email cadastrado para enviar a recuperação</p>
        <form @submit.prevent="send()" class="mx-auto grid grid-cols-2 gap-x-2 gap-y-4 pt-4 w-full md:w-3/5">
            <span class="col-span-2">
                <Input label="Email" type="email" v-model="state.email" :validation="v$.email"/>
            </span>
            <button type="submit" class="col-span-2 bg-indigo-700 h-10 rounded-md uppercase text-red-50">ENVIAR</button>
        </form>

        <span class="w-full flex">
          <button @click="$emit('clickToChange', 1)" class="mx-auto cursor-pointer text-sm text-center text-indigo-500 select-none mt-2">Retornar ao login</button>
        </span>
    </div>
</template>

<script>
import Input from '@/components/Design/Input'
import { reactive } from '@vue/reactivity'
import useVuelidate from '@vuelidate/core'
import { emailValidator } from '@/mixins/validators.js'
import { displayNotification } from '../../mixins/notification'
import { POST_REDEFINIR_SENHA } from '../../mixins/api'
import { onMounted } from '@vue/runtime-core'
export default {
    name: 'RequestRecovery',
    components: {
        Input
    },
    setup(_, {emit}) {
        const state = reactive({
            email: '',
        })

        const rules = {
            email: emailValidator(),
        }

        const send = (async () => {
            await POST_REDEFINIR_SENHA(state.email).then(r => {
                displayNotification(r)
                emit('clickToChange', 1)
            }).catch(e => {
                displayNotification(e.response)
            })
        })

        onMounted(async() => {
            await axios.get('/sanctum/csrf-cookie')
        })

        const v$ = useVuelidate(rules, state)

        return { 
            state,
            v$,
            send
        }
    }
}
</script>

<style>

</style>
